
export default function ComparisonSection() {
  const features = [
    {
      feature: 'Number of Pages',
      starter: '3 pages',
      professional: '5 pages',
      enterprise: 'Unlimited'
    },
    {
      feature: 'Delivery Time',
      starter: '2 weeks',
      professional: '1 week',
      enterprise: '5 days'
    },
    {
      feature: 'Revisions',
      starter: '3 included',
      professional: 'Unlimited',
      enterprise: 'Unlimited'
    },
    {
      feature: 'A/B Testing',
      starter: 'Basic',
      professional: 'Advanced',
      enterprise: 'Enterprise'
    },
    {
      feature: 'Analytics Setup',
      starter: 'Basic',
      professional: 'Advanced',
      enterprise: 'Enterprise'
    },
    {
      feature: 'Email Integration',
      starter: 'Basic',
      professional: 'Advanced',
      enterprise: 'Full Automation'
    },
    {
      feature: 'CRM Integration',
      starter: '✗',
      professional: 'Basic',
      enterprise: 'Advanced'
    },
    {
      feature: 'Account Manager',
      starter: '✗',
      professional: '✗',
      enterprise: 'Dedicated'
    },
    {
      feature: 'Monthly Optimization',
      starter: '✗',
      professional: '✗',
      enterprise: 'Included'
    },
    {
      feature: 'Training & Support',
      starter: 'Email',
      professional: 'Email + Chat',
      enterprise: 'Phone + Priority'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Compare Plans
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See exactly what's included in each plan to make the best choice for your business
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Features</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">Starter</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900 bg-blue-50">Professional</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">Enterprise</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {features.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">{item.feature}</td>
                    <td className="px-6 py-4 text-sm text-center text-gray-600">{item.starter}</td>
                    <td className="px-6 py-4 text-sm text-center text-gray-600 bg-blue-50/50">{item.professional}</td>
                    <td className="px-6 py-4 text-sm text-center text-gray-600">{item.enterprise}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}